import React from 'react';
import { Row, Col, Card } from 'reactstrap';
import CodeBlock from '../CodeBlock';

export default function CvPreviewSection() {
    return (
        <section id="cvpreview">
            <Row>
                <Col>
                    <h3>CV preview endpoint (/cv/preview/&#123;candidateId&#125;)</h3>
                    <p>
                        <code>GET</code> request to <code>/cv/preview/{`{candidateId}`}</code> returns an HTML string of the
                        candidates CV.
                    </p>
                    <p>Returns results only for non-anonymous candidates.</p>
                    <Card className="bg-dark text-white" body>
                        <h4>Curl Example</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`curl -X GET \\\n'https://recruiter.totaljobs.com/CandidateSearchApi/cv/preview/123456' \\\n-H 'authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto' \\\n-H 'cache-control: no-cache'`}
                        </CodeBlock>
                        <h4>REQUEST HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`Authorization: bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQ2FuZGlkYXRlIFNlYXJjaCBVc2VyIiwic2l0ZUlkIjoiNCIsInVuaXF1ZV9uYW1lIjoiMzM5MTc1YWQtMTEwNS00OWVkLTk3MzQtOTU0YzM5NzJjNTNjIiwiY2xpZW50SWQiOiIwMUQ0MzFCNy02REMwLTRERDEtQkYzMS0xRDQwNzlEMTI0QkEiLCJjbGllbnRVc2VySWQiOiJBIiwiaXNzIjoiUmVjcnVpdGVyIiwiYXVkIjoiYWxsIiwiZXhwIjoxNjE3MjcxODA3LCJuYmYiOjE2MTcyNzAwMDcsIlNzYVNlc3Npb25JZCI6ImNkODNjMTcyLThkZGUtNDEwNy1hNzRjLTY1NjlhMGU3YTQ2ZSJ9.gLBhEwpM5Ezh0PihC1ZCNdf4moZy2qNp1Y23NL_MYto`}
                        </CodeBlock>
                        <h4>RESPONSE HEADERS</h4>
                        <CodeBlock langauge="shell" theme="dark">
                            {`content-type: text/html\nstatus: 200 OK`}
                        </CodeBlock>
                        <h4>RESPONSE BODY</h4>
                        <CodeBlock langauge="json" theme="dark">
                            {`<html>candidate CV text</html>`}
                        </CodeBlock>
                    </Card>
                </Col>
            </Row>
        </section>
    )
}
